// Central list of all togglable admin pages.
// key   — stored in user.allowedPages[]
// label — shown in User Management UI
// route — the matching React Router path

export const PAGE_LIST = [
  { key: 'admin_dashboard',     label: 'Admin Dashboard',         route: '/admin',                          group: 'Core' },
  { key: 'admin_users',         label: 'User Management',         route: '/admin/users',                    group: 'Core' },
  { key: 'admin_access',        label: 'Access Control',          route: '/admin/access-control',           group: 'Core' },
  { key: 'admin_audit',         label: 'Audit Logs',              route: '/admin/audit-logs',               group: 'Core' },
  { key: 'admin_roles',         label: 'Role Management',         route: '/admin/roles',                    group: 'Core' },
  { key: 'admin_lifecycle',     label: 'User Lifecycle',          route: '/admin/lifecycle',                group: 'HR'   },
  { key: 'admin_recruitment',   label: 'Recruitment & Onboarding',route: '/admin/recruitment/onboarding',   group: 'HR'   },
  { key: 'admin_directory',     label: 'Master Directory',        route: '/admin/master-directory',         group: 'HR'   },
  { key: 'admin_equip_assign',  label: 'Equipment Assignment',    route: '/admin/equipment-assignment',     group: 'IT'   },
  { key: 'admin_equip_log',     label: 'Equipment Log',           route: '/admin/equipment-log',            group: 'IT'   },
  { key: 'admin_equip_return',  label: 'Equipment Return',        route: '/admin/equipment-return',         group: 'IT'   },
  { key: 'admin_documents',     label: 'Document Browser',        route: '/admin/documents',                group: 'IT'   },
  { key: 'admin_assets',        label: 'Asset Management',        route: '/admin/assets',                   group: 'IT'   },
  { key: 'admin_facility',      label: 'Facility Board',          route: '/admin/facility',                 group: 'Facility' },
  { key: 'admin_countries',     label: 'Country Management',      route: '/admin/countries',                group: 'Admin' },
  { key: 'admin_clients',       label: 'Client Management',       route: '/admin/clients',                  group: 'Admin' },
  { key: 'admin_emp_docs',      label: 'Employee Documents',      route: '/admin/employee-documents',       group: 'Admin' },
];

/** Returns true if the user has access to a page key.
 *  - SUPERADMIN always passes.
 *  - Empty allowedPages means all pages are allowed (legacy / newly-created user).
 */
export const canAccessPage = (user, pageKey) => {
  if (!user) return false;
  if (user.role === 'SUPERADMIN') return true;
  if (!user.allowedPages || user.allowedPages.length === 0) return true;
  return user.allowedPages.includes(pageKey);
};
